import { AvailabilityConstraintsProvider, ResourceProvider, ShopProvider } from 'hooks'
import { Navigate, Route, Routes } from 'react-router'
import { RouteParameters } from '../../constants'
import { Calendar } from './Calendar'
import { Index } from './Index/index'
import { List } from './List'

// Generated via https://ej2.syncfusion.com/themestudio/?theme=material
import { NotFound } from 'modules/NotFound'
import './material.min.css'

const { RESOURCE_ID: resourceId } = RouteParameters

const AvailabilityConstraints = () => (
  <ResourceProvider>
    <ShopProvider>
      <AvailabilityConstraintsProvider>
        <Routes>
          <Route element={<Index />} path="/">
            <Route element={<Navigate to="calendar" />} path="/" />
            <Route element={<Calendar />} path={`/:${resourceId}/*`} />
            <Route element={<Calendar />} path="calendar/*" />
            <Route element={<List />} path="list" />
          </Route>
          <Route element={<NotFound />} path="*" />
        </Routes>
      </AvailabilityConstraintsProvider>
    </ShopProvider>
  </ResourceProvider>
)

export { AvailabilityConstraints }
